/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { ReferenceMeasurementState } from './ReferenceMeasurementState';
import {
    ReferenceMeasurementStateFromJSON,
    ReferenceMeasurementStateFromJSONTyped,
    ReferenceMeasurementStateToJSON,
} from './ReferenceMeasurementState';

/**
 * 
 * @export
 * @interface TaskItemReferenceMeasurementInfoDto
 */
export interface TaskItemReferenceMeasurementInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    measurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {ReferenceMeasurementState}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    referenceMeasurementState?: ReferenceMeasurementState;
    /**
     * 
     * @type {string}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    creatorUserId?: number | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemReferenceMeasurementInfoDto
     */
    $type?: TaskItemReferenceMeasurementInfoDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemReferenceMeasurementInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemReferenceMeasurementInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemReferenceMeasurementInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemReferenceMeasurementInfoDtoTypeEnum = typeof TaskItemReferenceMeasurementInfoDtoTypeEnum[keyof typeof TaskItemReferenceMeasurementInfoDtoTypeEnum];


/**
 * Check if a given object implements the TaskItemReferenceMeasurementInfoDto interface.
 */
export function instanceOfTaskItemReferenceMeasurementInfoDto(value?: unknown): value is TaskItemReferenceMeasurementInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemReferenceMeasurementInfoDtoTypeEnum)[0];
}

export function TaskItemReferenceMeasurementInfoDtoFromJSON(json: any): TaskItemReferenceMeasurementInfoDto {
    return TaskItemReferenceMeasurementInfoDtoFromJSONTyped(json, false);
}

export function TaskItemReferenceMeasurementInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemReferenceMeasurementInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurementId': !exists(json, 'measurementId') ? undefined : json['measurementId'],
        'calibrationCertificateNumber': !exists(json, 'calibrationCertificateNumber') ? undefined : json['calibrationCertificateNumber'],
        'referenceMeasurementState': !exists(json, 'referenceMeasurementState') ? undefined : ReferenceMeasurementStateFromJSON(json['referenceMeasurementState']),
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskItemReferenceMeasurementInfoDtoToJSON(value?: TaskItemReferenceMeasurementInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'measurementId': value.measurementId,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'referenceMeasurementState': ReferenceMeasurementStateToJSON(value.referenceMeasurementState),
        'creationTime': value.creationTime,
        'creatorUserId': value.creatorUserId,
        'creatorUser': HistoryDtoUserToJSON(value.creatorUser),
        '$type': value.$type,
    });
}

